var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadCam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#808D9E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 25C22.6569 25 24 23.6569 24 22C24 20.3431 22.6569 19 21 19C19.3431 19 18 20.3431 18 22C18 23.6569 19.3431 25 21 25Z",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7778 30H23.2222C26.3433 30 27.9038 30 29.0248 29.2646C29.51 28.9462 29.9267 28.5371 30.251 28.0607C31 26.9601 31 25.4279 31 22.3636C31 19.2994 31 17.7672 30.251 16.6666C29.9267 16.1901 29.51 15.781 29.0248 15.4627C28.3044 14.9901 27.4027 14.8212 26.022 14.7609C25.3631 14.7609 24.7959 14.2707 24.6667 13.6364C24.4728 12.6849 23.6219 12 22.6337 12H19.3663C18.378 12 17.5271 12.6849 17.3333 13.6364C17.2041 14.2707 16.6368 14.7609 15.978 14.7609C14.5973 14.8212 13.6955 14.9901 12.9752 15.4627C12.4899 15.781 12.0733 16.1901 11.749 16.6666C11 17.7672 11 19.2994 11 22.3636C11 25.4279 11 26.9601 11.749 28.0607C12.0733 28.5371 12.4899 28.9462 12.9752 29.2646C14.0962 30 15.6567 30 18.7778 30Z",
    stroke: "white",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 19H27",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCam);
export default __webpack_public_path__ + "static/media/upload-cam.0f256a3c4e0bf7a5b553871338cc7afa.svg";
export { ForwardRef as ReactComponent };